import { SVGProps, Ref, forwardRef } from 'react';

export const ThumbDownOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.585 7.32c-.344 2.448.32 3.333 2.643 3.405h3.068v2.045c0 1.108.351 2.1 1.363 2.583.965.46 2.06-.217 2.143-1.236.119-1.459.755-2.671 1.879-4.07h.183c2.727 0 3.636-.909 3.636-3.637V4.137C15.5 1.41 14.59.5 11.864.5H4.932c-2.542.012-3.511.87-3.868 3.41zm10.312 1.467V1.9H4.935c-1.159.006-1.61.213-1.83.407-.223.197-.49.63-.654 1.798l-.48 3.41c-.166 1.182.006 1.494.044 1.544.007.008.178.23 1.235.266h4.446v3.445c0 .418.068.72.164.92a.8.8 0 0 0 .402.4.1.1 0 0 0 .042.01q.015.001.046-.016c.043-.025.055-.058.057-.08.15-1.852.971-3.326 2.182-4.834zm2.817-.525c-.134.134-.467.33-1.417.375V1.91c.95.046 1.283.241 1.417.375.154.154.386.566.386 1.852V6.41c0 1.287-.232 1.699-.386 1.852"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ThumbDownOutlinedSize16Glyph.displayName = 'ThumbDownOutlinedSize16Glyph';
